import React from 'react';
import { Mail, Phone, Zap } from 'lucide-react';

const Footer = () => {
  const navLinks = [
    { label: 'Hjem', href: '#hero' },
    { label: 'Oppdag', href: '#oppdag' },
    { label: 'Funksjoner', href: '#funksjoner' },
    { label: 'Anmeldelser', href: '#anmeldelser' },
    { label: 'Vanlige spørsmål', href: '#faq' },
  ];

  return (
    <footer className="bg-slate-950 border-t border-border-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Zap className="w-5 h-5 text-white" />
              </div>
              <span className="text-2xl font-bold font-heading">
                Workout <span className="text-primary-light">ON</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4 max-w-sm">
              Workout ON er din komplette treningsplattform med eksklusive videoer, sunne oppskrifter,
              treningssporing og motiverende innhold. Abonnement kr 39,-/uke. Tjenesten leveres av
              Skillbill B.V.
            </p>
            <p className="text-slate-500 text-xs leading-relaxed max-w-sm">
              Abonnementet er løpende og kan avsluttes når som helst ved å sende{' '}
              <strong className="text-slate-400">WO STOPP</strong> til 2210, sende e-post til
              no@workout-on.com, eller ringe +4721955881. Aldersgrense 18 år.
              Betaling belastes telefonregningen eller forhåndsbetalt saldo.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-5">Navigasjon</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-primary-light transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-5">Kontakt</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:no@workout-on.com"
                  className="flex items-center space-x-2 text-slate-400 hover:text-primary-light transition-colors text-sm"
                >
                  <Mail className="w-4 h-4 shrink-0" />
                  <span>no@workout-on.com</span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+4721955881"
                  className="flex items-center space-x-2 text-slate-400 hover:text-primary-light transition-colors text-sm"
                >
                  <Phone className="w-4 h-4 shrink-0" />
                  <span>+47 21 95 58 81</span>
                </a>
              </li>
            </ul>

            <div className="mt-6">
              <a
                href="/s"
                className="inline-flex items-center bg-primary hover:bg-primary-dark text-white px-5 py-2.5 rounded-lg font-semibold text-sm transition-colors shadow-lg shadow-primary/25"
              >
                Fortsett →
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border-dark pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} Workout ON. Tjenesten leveres av Skillbill B.V. Alle rettigheter forbeholdt.
          </p>
          <div className="flex space-x-6">
            <a href="/privacy.html" className="text-slate-500 hover:text-primary-light transition-colors text-xs">
              Personvernerklæring
            </a>
            <a href="/terms.html" className="text-slate-500 hover:text-primary-light transition-colors text-xs">
              Vilkår og betingelser
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
